import React, { useEffect } from "react";
import "./What_WinGo_Offers.css";
import Common_Title from "../../Common/Common_Component/Common_Title/Common_Title";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { useDispatch, useSelector } from "react-redux";
import { AllOffer } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

function What_WinGo_Offers() {

  const dispatch = useDispatch()
  const offer = useSelector((state) => state.common.all_offer);
  useEffect(() => {
    dispatch(AllOffer());
  }, [dispatch]);
  return (
    <>
      <section className="What_WinGo_Offers">
        <Common_Title title="What WinGo Offers" />

        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={5}
          slidesPerView={2.2}
          pagination={{ clickable: true }}
          //   autoplay={{ delay: 3000 }}
          loop={true}
          className="What_WinGo_Offers_slider common_swiper"
        >
          {/* Slide 1 */}

          {offer?.map((data) => (

            <SwiperSlide>
              <div className="img_holder">
                <img src={IDS.IMG_URL + data?.image} alt={data?.name} className="What_WinGo_Offers_img" />
              </div>
            </SwiperSlide>
          ))}

        </Swiper>
      </section>
    </>
  );
}

export default What_WinGo_Offers;
